import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import BrButton from '@components/BrButton';
import BrDropdownMenu from '@components/BrDropdownMenu';
import BrMultistateCheckboxDropdown from '@components/BrMultistateCheckboxDropdown';

export default class RowSelector extends PureComponent {
  static propTypes = {
    selectedRows: PropTypes.array.isRequired,
    selectableLength: PropTypes.number.isRequired,
    onHandleBatchSelect: PropTypes.func.isRequired,
    selectRowConfig: PropTypes.shape({
      batchSelectOptions: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.any.isRequired, // unique key
          title: PropTypes.string.isRequired, // option display text
          condition: PropTypes.func.isRequired, // data row will be passed as param  (row) => {}
        }),
      ),
      batchSelectActions: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.any.isRequired, // unique key
          title: PropTypes.string.isRequired, // option display text
          value: PropTypes.any, // if options not provided, this will become a standalone button
          onClick: PropTypes.func, // (selectedRows:array, actionItem:{key,value}) => {}
          options: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.any.isRequired,
              title: PropTypes.string.isRequired,
              onClick: PropTypes.func, // this will be called instead of onBatchSelectActions if provided.
              // (selectedRows:array, actionItem:{key,value}) => {}
            }),
          ),
        }),
      ),
      onClickAction: PropTypes.func, // (selectedRows:array, actionItem:{key,value}) => {}
    }),
  };

  handleSelectAction = (actionItem) => {
    const {
      selectedRows,
      selectRowConfig: { onClickAction },
    } = this.props;
    const callback = actionItem.onClick || onClickAction;

    if (callback) {
      callback(selectedRows, actionItem);
    }
  };

  render() {
    const {
      selectedRows,
      selectableLength,
      onHandleBatchSelect,
      selectRowConfig: { batchSelectOptions, batchSelectActions },
    } = this.props;

    return (
      <div className="br-table-data-selector">
        <BrMultistateCheckboxDropdown
          batchSelectOptions={batchSelectOptions}
          onBatchSelect={onHandleBatchSelect}
          selectableLength={selectableLength}
          selectedLength={selectedRows.length}
        />
        {!selectedRows.length
          ? null
          : batchSelectActions.map((actionGroup) => (actionGroup.options ? (
            <BrDropdownMenu
              key={actionGroup.key}
              title={actionGroup.title}
              items={actionGroup.options.map((op) => {
                op.key = actionGroup.key;
                return op;
              })}
              isReturnWholeItem
              onSelect={this.handleSelectAction}
            />
          ) : (
            <BrButton
              key={actionGroup.key}
              title={actionGroup.title}
              onClick={() => this.handleSelectAction(actionGroup)}
            />
          )))}
      </div>
    );
  }
}
